import { render, staticRenderFns } from "./ManagerSettingsBreadcrumb.vue?vue&type=template&id=677d65cb&scoped=true"
import script from "./ManagerSettingsBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./ManagerSettingsBreadcrumb.vue?vue&type=script&lang=ts"
import style0 from "./ManagerSettingsBreadcrumb.vue?vue&type=style&index=0&id=677d65cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677d65cb",
  null
  
)

export default component.exports